import {useContext, useState, useEffect} from "react";
import {Link, useLocation} from "react-router-dom";
import UserAdminComponent from "../components/Admin/UserAdminComponent";
import NavigationHeader from "../components/Layout/NavigationHeader";
import {
  getSiteAdminList,
  getClinicianList,
  getPatientList
} from "../common/BackendConnections";
import {
    patientRole,
    clinicianRole,
    adminRole,
    CapitalizeFirstLetter,
    notNull,
    hasUsername,
    AddUser,
    EditUser
} from "../common/UserManagement"
import UserActionDialog from "../components/Admin/UserActionDialog";
import nullUserInfo from "../components/Admin/UserInfo";
import AuthContext from "../store/auth-context";

const AdminPage = (props) => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {

    if (hash === '') {
      window.scrollTo(0, 0); // if not a hash link, scroll to top
    }
    else {
      // else scroll to id
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]);

  const [addingUserInfo, setAddingUserInfo] = useState(nullUserInfo);
  const [editingUserInfo, setEditingUserInfo] = useState(nullUserInfo);

  const getAddUserCallback = (userRole) => {
    return (onSuccessCallback) => {
      const _userInfo = {...nullUserInfo, userType: userRole, isActive: true, onSuccessCallback: onSuccessCallback};
      setAddingUserInfo(_userInfo);
    }
  }

  const getEditUserCallback = (userRole) => {
    return (userInfo, onSuccessCallback) => {
      const _userInfo = {...userInfo, userType: userRole, onSuccessCallback: onSuccessCallback};
      setEditingUserInfo(_userInfo);
    }
  }

  const authCtx = useContext(AuthContext);
  const isAdmin = authCtx.userRole === 'admin'

  const id_admin = "administrators"
  const id_clinician = "clinicians"
  const id_patient = "patients"

  return(
    <section className={"page_content"}>
      <NavigationHeader />
      <div>
        <h1>User management</h1>
        <ul>
          {isAdmin &&
            <li><Link to={`#${id_admin}`}>Manage administrators</Link></li>
          }
          <li><Link to={`#${id_clinician}`}>Manage clinicians</Link></li>
          <li><Link to={`#${id_patient}`}>Manage patients</Link></li>
        </ul>
        <hr style={{marginTop: "3rem", marginBottom: "5rem"}}/>
      </div>

      {isAdmin &&
        <div id={`${id_admin}`}>
          <UserAdminComponent heading="Administrator"
                              userRole={adminRole}
                              getUserList={getSiteAdminList}
                              addUser={getAddUserCallback(adminRole)}
                              editUser={getEditUserCallback(adminRole)}
          />
        </div>
      }
      <div id={`${id_clinician}`}>
        <UserAdminComponent userRole={clinicianRole}
                            getUserList={getClinicianList}
                            addUser={getAddUserCallback(clinicianRole)}
                            editUser={getEditUserCallback(clinicianRole)}
        />
      </div>
      <div id={`${id_patient}`}>
        <UserAdminComponent userRole={patientRole}
                            getUserList={getPatientList}
                            addUser={getAddUserCallback(patientRole)}
                            editUser={getEditUserCallback(patientRole)}
        />
        <Link to="">Back to top</Link>
      </div>

      {/*Modal dialog for adding a new user*/}
      {notNull(addingUserInfo) &&
        <UserActionDialog windowTitle={"Add " + CapitalizeFirstLetter(addingUserInfo.userType) + " User"}
                          show={true}
                          userType={addingUserInfo.userType}
                          hasEmail={true}
                          hasUsername={hasUsername(addingUserInfo)}
                          defaultUserInfo={addingUserInfo}
                          handleFormExit={() => {setAddingUserInfo(nullUserInfo)}}
                          processFormData={AddUser} />
      }

      {/*Modal dialog for editing an existing user*/}
      {notNull(editingUserInfo) &&
        <UserActionDialog windowTitle={"Edit " + CapitalizeFirstLetter(editingUserInfo.userType) + " User"}
                          show={true}
                          userType={editingUserInfo.userType}
                          hasEmail={true}
                          hasUsername={hasUsername(editingUserInfo)}
                          defaultUserInfo={editingUserInfo}
                          handleFormExit={() => {setEditingUserInfo(nullUserInfo)}}
                          processFormData={EditUser} />
      }

    </section>);
};

export default AdminPage;
